const knowledgeQuizApi = '/knowledge-quiz';

export const getUserKnowledgeQuizPath = () => knowledgeQuizApi;
export const startUserKnowledgeQuizPath = () => knowledgeQuizApi;
export const answerUserKnowledgeQuizPath = (userKnowledgeQuizId: string) =>
  `${knowledgeQuizApi}/${userKnowledgeQuizId}/answer`;
export const finishUserKnowledgeQuizPath = (userKnowledgeQuizId: string) =>
  `${knowledgeQuizApi}/${userKnowledgeQuizId}/finish`;
